import type {FilterObject} from 'nutshell-core/types';

import type {
    InstallmentsListApiResponse,
    InstallmentsReportApiResponse,
    InstallmentsReportFacet,
} from './installments-report-api';

export const ActionTypes = {
    INSTALLMENTS_REPORT_FETCH_REQUEST: 'INSTALLMENTS_REPORT_FETCH_REQUEST',
    INSTALLMENTS_REPORT_FETCH_SUCCESS: 'INSTALLMENTS_REPORT_FETCH_SUCCESS',
    INSTALLMENTS_REPORT_FETCH_FAILURE: 'INSTALLMENTS_REPORT_FETCH_FAILURE',
    INSTALLMENTS_LIST_FETCH_REQUEST: 'INSTALLMENTS_LIST_FETCH_REQUEST',
    INSTALLMENTS_LIST_FETCH_SUCCESS: 'INSTALLMENTS_LIST_FETCH_SUCCESS',
    INSTALLMENTS_LIST_FETCH_FAILURE: 'INSTALLMENTS_LIST_FETCH_FAILURE',
} as const;

export type InstallmentsReportRequestPayload = {
    activeFilters: FilterObject[];
    gap: string;
    facet: InstallmentsReportFacet;
    includeOpenLeads: boolean;
};

export type InstallmentsReportRequestAction = {
    type: typeof ActionTypes.INSTALLMENTS_REPORT_FETCH_REQUEST;
    payload: InstallmentsReportRequestPayload;
};

export type InstallmentsReportSuccessAction = {
    type: typeof ActionTypes.INSTALLMENTS_REPORT_FETCH_SUCCESS;
    payload: InstallmentsReportApiResponse;
};

export type InstallmentsReportFailureAction = {
    type: typeof ActionTypes.INSTALLMENTS_REPORT_FETCH_FAILURE;
    error: true;
    payload: unknown;
};

export type InstallmentsReportAction =
    | InstallmentsReportRequestAction
    | InstallmentsReportSuccessAction
    | InstallmentsReportFailureAction
    | InstallmentsListRequestAction
    | InstallmentsListSuccessAction
    | InstallmentsListFailureAction;

export type InstallmentsListRequestPayload = {
    activeFilters: FilterObject[];
    page: number;
    limit: number;
    sort: string;
    facet: InstallmentsReportFacet;
    includeOpenLeads: boolean;
};

export type InstallmentsListRequestAction = {
    type: typeof ActionTypes.INSTALLMENTS_LIST_FETCH_REQUEST;
    payload: InstallmentsListRequestPayload;
};

export type InstallmentsListSuccessAction = {
    type: typeof ActionTypes.INSTALLMENTS_LIST_FETCH_SUCCESS;
    payload: InstallmentsListApiResponse;
};

export type InstallmentsListFailureAction = {
    type: typeof ActionTypes.INSTALLMENTS_LIST_FETCH_FAILURE;
    error: true;
    payload: unknown;
};

export const requestInstallmentsReport = (
    payload: InstallmentsReportRequestPayload
): InstallmentsReportRequestAction => ({
    type: ActionTypes.INSTALLMENTS_REPORT_FETCH_REQUEST,
    payload,
});

export const resolveInstallmentsReport = (
    payload: InstallmentsReportApiResponse
): InstallmentsReportSuccessAction => ({
    type: ActionTypes.INSTALLMENTS_REPORT_FETCH_SUCCESS,
    payload,
});

export const failInstallmentsReport = (err: unknown): InstallmentsReportFailureAction => ({
    type: ActionTypes.INSTALLMENTS_REPORT_FETCH_FAILURE,
    payload: err,
    error: true,
});

export const requestInstallmentsList = (
    payload: InstallmentsListRequestPayload
): InstallmentsListRequestAction => ({
    type: ActionTypes.INSTALLMENTS_LIST_FETCH_REQUEST,
    payload,
});

export const resolveInstallmentsList = (
    payload: InstallmentsListApiResponse
): InstallmentsListSuccessAction => ({
    type: ActionTypes.INSTALLMENTS_LIST_FETCH_SUCCESS,
    payload,
});

export const failInstallmentsList = (err: unknown): InstallmentsListFailureAction => ({
    type: ActionTypes.INSTALLMENTS_LIST_FETCH_FAILURE,
    payload: err,
    error: true,
});
